module.exports = __webpack_public_path__ + "img/food5.efb833d4.jpeg";